import { z } from 'zod';

import { SurveyQuestionsSchema } from './survey-questions';

export const SurveySchema = z.object({
  id: z.string().uuid(),
  questions: z.array(
    SurveyQuestionsSchema.pick({ surveyQuestionHistoryId: true, type: true, label: true }).extend({
      answer: z.string().nullable(),
    }),
  ),
});
